const routMain = () => '/contact';

export default routMain;